import {appApi} from "@services/api.service";

const endpointPrefix = 'worker/proposals';

export type ProposalActionResponse = {
    result: 'success' | 'error';
    message?: string;
};

const acceptProposal = async (id: number, confirmPlaceAddition: boolean | null = null, adjustAvailability: boolean = false) => {
    return appApi.post(endpointPrefix + '/' + id + '/accept', {
        confirmPlaceAddition,
        adjustAvailability,
    }, {
        headers: {'No-Loader': true},
    });
}

const rejectProposal = async (id: number, reason: string, replacement: string | null = null) => {
    return appApi.post(endpointPrefix + '/' + id + '/reject', {
        reason,
        replacement,
    }, {
        headers: {'No-Loader': true},
    });
}

export {
    acceptProposal,
    rejectProposal,
};
